import PropTypes from "prop-types";
import React from "react";
import validator from "validator";
import { FORM_FIELDS, FORM_TEXTS, FORM_VALIDATION } from "../../constants";
import { FormTextInput } from "../core";
import { blockedDomain } from "../serviceprovider/helper/blockedDomains";

export const ContactDetails = ({ register, errors, handleChange }) => {
  const checkBlockedDomain = (email) => {
    const domain = email.split("@")[1]?.toLowerCase();
    if (blockedDomain.includes(domain)) {
      return FORM_VALIDATION.BUSINESS_EMAIL;
    }
    return true;
  };
  return (
    <>
      <fieldset className="mt-4 border-2 border-white border-t-black p-1">
        <legend className="uppercase text-xl font-semibold">
          {FORM_TEXTS.PRIMARY_CONTACT_DETAILS}
          <sup className="text-red-500 font-bold text-lg ml-1">*</sup>
        </legend>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-5">
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_NAME}
            id="primaryName"
            onChange={handleChange}
            {...register("primaryName", {
              required: FORM_VALIDATION.CONTACT_NAME,
            })}
            error={errors.primaryName}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_EMAIL}
            id="primaryEmail"
            onChange={handleChange}
            {...register("primaryEmail", {
              required: FORM_VALIDATION.CONTACT_EMAIL,
              validate: (value) => {
                if (!validator.isEmail(value)) {
                  return FORM_VALIDATION.INVALID_CONTACT_EMAIL;
                }
                return checkBlockedDomain(value);
              },
            })}
            error={errors.primaryEmail}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_PHONE}
            id="primaryPhone"
            onChange={handleChange}
            {...register("primaryPhone", {
              required: FORM_VALIDATION.CONTACT_PHONE,
              validate: (value) => {
                if (!validator.isMobilePhone(value)) {
                  return FORM_VALIDATION.INVALID_CONTACT_PHONE;
                }
                return true;
              },
            })}
            error={errors.primaryPhone}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_TITLE}
            id="primaryTitle"
            onChange={handleChange}
            {...register("primaryTitle", {
              required: FORM_VALIDATION.CONTACT_TITLE,
            })}
            error={errors.primaryTitle}
          />
        </div>
      </fieldset>
      <fieldset className="mt-4 border-2 border-white border-t-black p-1">
        <legend className="uppercase text-xl font-semibold">
          {FORM_TEXTS.SECONDARY_CONTACT_DETAILS}
        </legend>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-5">
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_NAME}
            id="secondaryName"
            onChange={handleChange}
            {...register("secondaryName")}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_EMAIL}
            id="secondaryEmail"
            onChange={handleChange}
            {...register("secondaryEmail", {
              validate: (value) => {
                if (value !== "") {
                  if (!validator.isEmail(value)) {
                    return FORM_VALIDATION.INVALID_CONTACT_EMAIL;
                  }
                  return checkBlockedDomain(value);
                }
                return true;
              },
            })}
            error={errors.secondaryEmail}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_PHONE}
            id="secondaryPhone"
            onChange={handleChange}
            {...register("secondaryPhone", {
              validate: (value) => {
                if (value !== "" && !validator.isMobilePhone(value)) {
                  return FORM_VALIDATION.INVALID_CONTACT_PHONE;
                }
                return true;
              },
            })}
            error={errors.secondaryPhone}
          />
          <FormTextInput
            labelName={FORM_FIELDS.CONTACT_TITLE}
            id="secondaryTitle"
            onChange={handleChange}
            {...register("secondaryTitle")}
          />
        </div>
      </fieldset>
    </>
  );
};

ContactDetails.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
  errors: PropTypes.object,
};
